import { useMutation, useQueryClient } from '@tanstack/react-query'
import { User } from '@/src/types/user'
import { useToken } from '@/src/store/token-store'
import { useUser } from '@/src/store/user-store'
import { makeApiRequest } from '@/src/lib/api-request'
import { encryptPassword } from '@/src/lib/utils'

export type LoginUserMutationParams = {
  email: string
  password: string
  type: 'normal' | 'business'
  inputType: 'email' | 'phone'
}

export const useLoginMutation = () => {
  const queryClient = useQueryClient()
  const { setToken } = useToken()
  const { setUser, setRefreshToken } = useUser()
  return useMutation({
    mutationKey: ['user', 'login'],
    mutationFn: async (params: LoginUserMutationParams) => {
      const response = await makeApiRequest({
        method: 'POST',
        url:
          params.type === 'normal'
            ? '/Login_New/normalUserLogin'
            : '/Login_New/businessUserLogin',
        data: {
          phone: params.email,
          password: encryptPassword(params.password),
          type: params.inputType,
        },
        isAuthenticated: false,
        fallbackError: 'Error while logging in',
        isV3Api: true,
      })

      setToken(response.token)
      setRefreshToken(response.refresh_token)
      setUser(response.response)
      return response.response as User
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user', 'me'] })
    },
  })
}
